<template>
  <div class="topbar">
    <div v-if="disclaimer.display" class="disclaimer">
      <span id="beta">{{ disclaimer.header }}</span>&ensp;&ensp;
      <span>{{ disclaimer.text }} <a v-if="disclaimer.displayLink"
          class="clickable-text" @click="openModal('ReportModal')">{{ disclaimer.linkText }}</a></span>
    </div>
    <div class="topbar-content">
      <div class="topbar-intro">
        <h1>
          <span>StudyPlanner</span>
        </h1>
        <h2 class="subtitle">
          <span>TUM School of Computation, Information and Technology</span>
        </h2>
      </div>
      <div class="topbar-tools">
        <div class="tool tooltip-container notification" v-if="hasSolution" @click="openShareModal">
          <div class="icon-container">
            <span class="material-symbols-outlined print">share</span>
            <span class="material-symbols-outlined new-icon">fiber_new</span>
          </div>
          <div class="tooltip-text bottom">Save/Share plan</div>
          <div class="tool-label">Save/Share Plan</div>
        </div>
        <div class="tool tooltip-container notification" v-if="hasSolution" @click="handleDownloadPDF">
          <div class="icon-container">
            <span class="material-symbols-outlined print">picture_as_pdf</span>
          </div>
          <div class="tooltip-text bottom">Export</div>
          <div class="tool-label">Export (PDF)</div>
        </div>
        <div class="tool tooltip-container notification" v-if="hasSolution" @click="handleDownloadExcel">
          <div class="icon-container">
            <span class="material-symbols-outlined print">table_view</span>
          </div>
          <div class="tooltip-text bottom">Export in XLSX format</div>
          <div class="tool-label">Export (XLSX)</div>
        </div>
        <div class="tool tooltip-container" @click="openModal('PrivacyModal')">
          <span class="material-symbols-outlined">admin_panel_settings</span>
          <div class="tooltip-text bottom">Privacy</div>
          <div class="tool-label">Privacy</div>
        </div>
        
        <div :class="{ 'highlight': showError }" class="tool tooltip-container" @click="openModal('ReportModal')">
          <span class="material-symbols-outlined">feedback</span>
          <div class="tooltip-text bottom">Give feedback or report a problem</div>
          <div class="tool-label">Feedback</div>
        </div>
        <div class="tool tooltip-container" @click="openModal('ImprintModal')">
          <span class="material-symbols-outlined">fingerprint</span>
          <div class="tooltip-text bottom">Imprint</div>
          <div class="tool-label">Imprint</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {disclaimer} from "../../options.config";

export default {
  name: "TopBar",
  data() {
    return {
      isProduction: process.env.NODE_ENV === 'production'
    };
  },
  computed: {
    ...mapState(["hasSolution", "errorOccurred", "preferences", "schedule", "blockCredits", "hasSolution"]),
    ...mapGetters(["reqPrefsSet", "prefChangeDisabled", "addedPassedModules"]),
    showError() {
      return this.errorOccurred ||
          (!this.prefChangeDisabled && this.reqPrefsSet && this.addedPassedModules && !this.hasSolution);
    },
    disclaimer() {
      return disclaimer;
    }
  },
  methods: {
    ...mapActions(["openModal"]),
    ...mapMutations(["UPDATE_DECODED_SAVE_DATA"]),
    async handleDownloadPDF() {
      try {
      const preferences = this.$store.state.preferences;
      const schedule = this.$store.state.schedule;
      const blockCredits = this.$store.state.blockCredits;
      const adress = window.location.href.split('/save/')[0].replace(/\/*$/,"");
      const response = await axios.post(process.env.VUE_APP_API_URL + "/api/pdf", {
          preferences, schedule, blockCredits, adress
      }, {
          responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'StudyPlan.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      } catch (error) {
      console.error("Failed to download PDF:", error);
      }
    },
    async handleDownloadExcel() {
      try {
        const preferences = this.$store.state.preferences;
        const schedule = this.$store.state.schedule;
        const blockCredits = this.$store.state.blockCredits;
        const adress = window.location.href.split('/save/')[0].replace(/\/*$/,"");
        const response = await axios.post(process.env.VUE_APP_API_URL + "/api/excel", {
            preferences, schedule, blockCredits, adress
        }, {
            responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'StudyPlan.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Failed to download Excel:", error);
      }
    },
    async openShareModal() {
      try {
      const preferences = this.$store.state.preferences;
      const response = await axios.post(process.env.VUE_APP_API_URL + "/api/encode", preferences);
      
      const url = window.location.origin + "/save/" + response.data['encoded'];
      this.$store.commit('UPDATE_ENCODED_SAVE_DATA', {encoding:url});
    
      } catch (error) {
      console.error("Failed to encode preferences:", error);
      }
      this.openModal('ShareModal');
    }
    }
};
</script>

<style scoped>
.topbar {
  width: 100vw;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2; /* higher z-index to make sure shadow of topbar is visible */
}

.disclaimer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  background-color: #D95117;
}

.disclaimer span {
  text-align: center;
  margin: 5px 0;
}

.clickable-text {
  cursor: pointer;
  text-decoration: underline;
}

#beta {
  font-size: 16px;
  font-weight: bold;
}

.topbar-content {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topbar-intro {
  margin: 10px 20px;
}

.subtitle {
  color: #6A757E;
  font-weight: normal;
}

.topbar-tools {
  display: flex;
  margin: 10px 20px;
}

.tool {
  display: flex;
  justify-content: center;
  padding: 5px;
  margin: 5px;
  color: #6A757E;
  cursor: pointer;
  border-radius: 50%; /* Makes the background round */
  box-sizing: border-box;
  height: 34px;
  transition: color 0.2s, background-color 0.2s ease;
}

.icon-container {
  position: relative;
  display: inline-block;
}


.new-icon {
  position: absolute;
  top: -18px;
  right: -14px;
  font-size: 28px;
  color: #28a745;
}

.tool-label {
  margin-left: 5px;
  font-size: 12px;
  white-space: nowrap;
  color: inherit;
}

.tool:hover {
  color: #20252A;
  background-color: rgba(68, 71, 70, 0.08);

}

.tool.highlight {
  color: #F3B295;
}

.tool.highlight:hover {
  color: #EA7237;
}

.print{
  animation: hithere 1s ease 1  ;
}

@keyframes hithere {
  30% { transform: scale(1.2); }
  40%, 60% { transform: rotate(-20deg) scale(1.2); }
  50% { transform: rotate(20deg) scale(1.2); }
  70% { transform: rotate(0deg) scale(1.2); }
  100% { transform: scale(1); }
}

</style>
<script setup>
</script>